import React, { useState } from 'react';

function SearchForm({ onSearch, isLoading, progress }) {
  const [keywords, setKeywords] = useState('');
  const [region, setRegion] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch({ keywords, region });
  };

  return (
    <div className="search-page-container">
      <div className="search-content">
        <h1 className="app-title">Transo</h1>
        
        <form className="search-form" id="searchForm" onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              id="keywords"
              value={keywords}
              onChange={e => setKeywords(e.target.value)}
              placeholder="Enter keywords"
              required
              disabled={isLoading}
            />
          </div>
          
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              id="region"
              value={region}
              onChange={e => setRegion(e.target.value)}
              placeholder="Region"
              required
              disabled={isLoading}
            />
          </div>
          
          <button type="submit" className="search-button" disabled={isLoading}>
            {isLoading ? 'Searching...' : 'Search'}
          </button>
        </form>

        {/* Progress bar */}
        {isLoading && (
          <div className="progress-container">
            <div className="progress-status">
              {progress ? progress.current_step_name : 'Initializing search...'}
            </div>
            <div className="progress">
              <div 
                className="progress-bar" 
                role="progressbar" 
                style={{ width: progress ? `${progress.percentage}%` : '0%' }}
                aria-valuenow={progress ? progress.percentage : 0} 
                aria-valuemin="0" 
                aria-valuemax="100"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SearchForm;
